import {ContextSync} from "@project/extensions/ai-assistant";
import {AppErrorBoundary, AppShell} from "@project/layouts";
import {routes} from "@project/router";
import {Outlet, createFileRoute, redirect} from "@tanstack/react-router";

import {AuthenticatedSessionEffects} from "../../layouts/app-shell/authenticated-session-effects";

/**
 * Pathless authenticated layout route.
 *
 * All routes nested inside `_app/` require authentication.
 * The `_app` prefix is stripped from the URL — children own their own path segments.
 *
 * Auth is session-backed through the BFF contract. Mock mode answers the same
 * `/api/security/auth/session` endpoint through MSW and returns an authenticated user.
 */
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({context, location}) => {
    const session = await context.auth.getSession();

    if (!session.authenticated) {
      throw redirect({
        search: {redirect: location.href},
        to: routes.login(),
      });
    }
  },
  component: AppLayout,
  errorComponent: AppErrorBoundary,
});

function AppLayout() {
  return (
    <AppShell>
      <AuthenticatedSessionEffects />
      <ContextSync />
      <Outlet />
    </AppShell>
  );
}
